import { API, httpParamsSerialize } from "./api";

const MediaIdeaService = {
  getByFilter: (query, params) => {
    const url = `/api/mediaCard/getByFilter?${httpParamsSerialize(query)}`;
    return API.post(url, params).then((data) => data?.data);
  },

  getById: (id: string) => {
    const url = `/api/mediaCard/getById?id=${encodeURIComponent(id)}`;
    return API.get(url).then((data) => data?.data);
  },

  like: (id: string) =>
    API.post("/api/mediaCard/like", { id }).then((data) => data?.data),

  unlike: (id: string) =>
    API.post("/api/mediaCard/unlike", { id }).then((data) => data?.data),
};

export default MediaIdeaService;
